import { OfferScopeOfWorkAddDialogConfig } from "../offer/components/offer-scope-of-work-add-dialog";

export const omniOfferScopeOfWorkAddDialogConfig: OfferScopeOfWorkAddDialogConfig =
  {
    selectBaseData: false,
    selectServiceVariation: false,
  };
